import { Eye } from 'lucide-react';
import { useGetSupportPartner } from '@/api/control/control-plane/control-plane';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';
import { fillSupportTemplate } from '@/lib/support';

interface VisibilityCardProps {
  orgId: string;
}

/**
 * Explains who can see and comment on the organization's tickets, naming the partner when one is
 * assigned.
 */
export function VisibilityCard({ orgId }: VisibilityCardProps) {
  const { t } = useLanguage();
  const { data } = useGetSupportPartner(orgId, { query: { retry: false } });
  // The partner endpoint returns null when the organization has no partner.
  const partner = data?.data ?? null;
  const partnerName = partner?.name;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Eye className="h-5 w-5 text-muted-foreground" aria-hidden />
          {t.support.visibility.title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm">
          {partnerName
            ? fillSupportTemplate(t.support.visibility.withPartner, { name: partnerName })
            : t.support.visibility.withoutPartner}
        </p>
      </CardContent>
    </Card>
  );
}
